import { useParams } from "react-router-dom";
import QuadrantSection from "../QuadrantSection/QuadrantSection";
import SetTitle from "../SetTitle";
import { useRadarConfiguration } from "../../hooks/UseRadarConfiguration";
import { dataConfigTransform } from "../../contentful/transformers/config/config";
import { dataRadarTransform } from "../../contentful/transformers/radar/radar";

import { translate } from "../../config";
import { featuredOnly, groupByQuadrants } from "../../model";
import HeadlineGroup from "../HeadlineGroup/HeadlineGroup";
import HeroHeadline from "../HeroHeadline/HeroHeadline";

export default function PageQuadrant() {
  const { radarName, quadrantName: pageName } = useParams();

  const { data: radarData } = useRadarConfiguration(radarName);

  const items = radarData && dataRadarTransform(radarData).items;
  const config = radarData && dataConfigTransform(radarData);

  const groups = groupByQuadrants(featuredOnly(items ?? []));
  return (
    <>
      {config && (
        <>
          <SetTitle title={translate(config, pageName || "")} />
          <HeadlineGroup>
            <HeroHeadline>{translate(config, pageName || "")}</HeroHeadline>
          </HeadlineGroup>
          <QuadrantSection
            groups={groups}
            quadrantName={pageName || ""}
            config={config}
            big
            showHeadline={false}
          />
        </>
      )}
    </>
  );
}
